const isEmptyObject = object => Object.keys(object).length === 0

export default isEmptyObject



// WEBPACK FOOTER //
// ./src/utility/isEmptyObject.js